import * as React from "react";
import { SVGProps } from "react";

const UserNotFound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={25}
    height={24}
    {...props}
  >
    <path
      fill="#1A1C1F"
      d="M12.5 12.75c-3.17 0-5.75-2.58-5.75-5.75s2.58-5.75 5.75-5.75S18.25 3.83 18.25 7s-2.58 5.75-5.75 5.75Zm0-10A4.26 4.26 0 0 0 8.25 7a4.26 4.26 0 0 0 4.25 4.25A4.26 4.26 0 0 0 16.75 7a4.26 4.26 0 0 0-4.25-4.25ZM3.91 22.75c-.41 0-.75-.34-.75-.75 0-4.27 4.19-7.75 9.34-7.75 1.01 0 2 .13 2.96.4.4.11.63.52.52.92-.11.4-.52.63-.92.52-.82-.23-1.68-.34-2.56-.34-4.32 0-7.84 2.8-7.84 6.25 0 .41-.34.75-.75.75Z"
    />
    <path
      fill="#1A1C1F"
      d="M18.5 22.75a4.7 4.7 0 0 1-3.17-1.23c-.35-.3-.66-.67-.9-1.08-.44-.72-.68-1.57-.68-2.44 0-1.25.48-2.42 1.34-3.31.9-.93 2.11-1.44 3.41-1.44 1.36 0 2.65.58 3.53 1.58A4.74 4.74 0 0 1 23.25 18c0 .38-.05.76-.15 1.12-.1.45-.29.92-.55 1.33-.83 1.42-2.39 2.3-4.05 2.3Zm0-8a3.241 3.241 0 0 0-2.78 4.92c.16.28.37.53.61.74.6.55 1.37.85 2.17.85 1.13 0 2.2-.6 2.78-1.57.17-.28.3-.6.37-.91.07-.26.1-.51.1-.77 0-.8-.3-1.57-.84-2.17-.6-.7-1.48-1.09-2.41-1.09Z"
    />
    <path
      fill="#1A1C1F"
      d="M17.42 19.8c-.19 0-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L19 16.41c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2.11 2.11c-.15.15-.34.22-.53.22Z"
    />
    <path
      fill="#1A1C1F"
      d="M19.56 19.82c-.19 0-.38-.07-.53-.22l-2.11-2.11a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.11 2.11c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z"
    />
  </svg>
);
export default UserNotFound;
